import SubCategories from './subCategories'
export default SubCategories
